import { TranslationKeys } from '@pascal/pascal-core';

/**
 * @enum {string}
 * @type {Object<string, string>}
 */
export const TKeys = Object.assign(TranslationKeys, {
  BetCanceled: 'BET_CANCELED',
  YourBetIsAccepted: 'YOUR_BET_IS_ACCEPTED',
  NotEnoughBalance: 'NOT_ENOUGH_BALANCE',
  InvalidToken: 'INVALID_TOKEN',
  InvalidAmount: 'INVALID_AMOUNT',
  BuyBonusDisabled: 'BUY_BONUS_DISABLED',
  PartnerNotFound: 'PARTNER_NOT_FOUND',
  UnHandledError: 'UN_HANDLED_ERROR',
  YouWin: 'YOU_WIN',
  GameRules: 'GAME_RULES_P',
  Start: 'START',
  CashOut: 'CASHOUT',
  RESULT: 'RESULT'
});